import { create } from 'zustand'

/**
 * Минимальный store для UI состояния корзины
 * 
 * Основные данные корзины хранятся на сервере и загружаются через useCart().
 * Этот store только для UI: модалки, анимации, локальный кэш для быстрого доступа.
 */
interface CartUIState {
  /** Открыто ли bottom sheet корзины */
  isCartSheetOpen: boolean
  /** ID товара, для которого показывается выбор веса */
  weightSelectorProductId: string | null
  
  // Действия
  openCartSheet: () => void
  closeCartSheet: () => void
  openWeightSelector: (productId: string) => void
  closeWeightSelector: () => void
}

export const useCartStore = create<CartUIState>((set) => ({
  isCartSheetOpen: false,
  weightSelectorProductId: null,

  openCartSheet: () => set({ isCartSheetOpen: true }),
  closeCartSheet: () => set({ isCartSheetOpen: false }),
  
  openWeightSelector: (productId) => set({ weightSelectorProductId: productId }),
  closeWeightSelector: () => set({ weightSelectorProductId: null }),
}))
